var map = {
	"./categories/carousel/banking-and-finance": 44,
	"./categories/carousel/banking-and-finance.jpg": 44,
	"./categories/carousel/business-innovation": 45,
	"./categories/carousel/business-innovation.jpg": 45,
	"./categories/carousel/companies": 46,
	"./categories/carousel/companies.jpg": 46,
	"./categories/carousel/countries-and-cultures": 47,
	"./categories/carousel/countries-and-cultures.jpg": 47,
	"./categories/carousel/economy": 48,
	"./categories/carousel/economy.jpg": 48,
	"./categories/carousel/education": 49,
	"./categories/carousel/education-and-corporate-training": 50,
	"./categories/carousel/education-and-corporate-training.jpg": 50,
	"./categories/carousel/education.jpg": 49,
	"./categories/carousel/employment": 51,
	"./categories/carousel/employment.jpg": 51,
	"./categories/carousel/environment": 52,
	"./categories/carousel/environment.jpg": 52,
	"./categories/carousel/finance-and-money": 53,
	"./categories/carousel/finance-and-money.jpg": 53,
	"./categories/carousel/government-and-law": 54,
	"./categories/carousel/government-and-law.jpg": 54,
	"./categories/carousel/industries": 55,
	"./categories/carousel/industries.jpg": 55,
	"./categories/carousel/international-politics": 56,
	"./categories/carousel/international-politics.jpg": 56,
	"./categories/carousel/internet-and-new-economy": 57,
	"./categories/carousel/internet-and-new-economy.jpg": 57,
	"./categories/carousel/internet-and-technology": 58,
	"./categories/carousel/internet-and-technology.jpg": 58,
	"./categories/carousel/management": 59,
	"./categories/carousel/management.jpg": 59,
	"./categories/carousel/marketing": 60,
	"./categories/carousel/marketing.jpg": 60,
	"./categories/carousel/media": 61,
	"./categories/carousel/media.jpg": 61,
	"./categories/carousel/news": 62,
	"./categories/carousel/news.jpg": 62,
	"./categories/carousel/people": 63,
	"./categories/carousel/people.jpg": 63,
	"./categories/carousel/science": 64,
	"./categories/carousel/science.jpg": 64,
	"./categories/carousel/society-and-the-wider-world": 65,
	"./categories/carousel/society-and-the-wider-world.jpg": 65,
	"./categories/carousel/technology-and-innovation": 66,
	"./categories/carousel/technology-and-innovation.jpg": 66,
	"./categories/carousel/transport-and-travel": 67,
	"./categories/carousel/transport-and-travel.jpg": 67,
	"./categories/carousel/working-practices": 68,
	"./categories/carousel/working-practices.jpg": 68,
	"./categories/headers/banking-and-finance": 69,
	"./categories/headers/banking-and-finance.jpg": 69,
	"./categories/headers/business-innovation": 70,
	"./categories/headers/business-innovation.jpg": 70,
	"./categories/headers/companies": 71,
	"./categories/headers/companies.jpg": 71,
	"./categories/headers/countries-and-cultures": 72,
	"./categories/headers/countries-and-cultures.jpg": 72,
	"./categories/headers/economy": 73,
	"./categories/headers/economy.jpg": 73,
	"./categories/headers/education": 74,
	"./categories/headers/education-and-corporate-training": 75,
	"./categories/headers/education-and-corporate-training.jpg": 75,
	"./categories/headers/education.jpg": 74,
	"./categories/headers/employment": 76,
	"./categories/headers/employment.jpg": 76,
	"./categories/headers/environment": 77,
	"./categories/headers/environment.jpg": 77,
	"./categories/headers/finance-and-money": 78,
	"./categories/headers/finance-and-money.jpg": 78,
	"./categories/headers/government-and-law": 79,
	"./categories/headers/government-and-law.jpg": 79,
	"./categories/headers/industries": 80,
	"./categories/headers/industries.jpg": 80,
	"./categories/headers/international-politics": 81,
	"./categories/headers/international-politics.jpg": 81,
	"./categories/headers/internet-and-new-economy": 82,
	"./categories/headers/internet-and-new-economy.jpg": 82,
	"./categories/headers/internet-and-technology": 83,
	"./categories/headers/internet-and-technology.jpg": 83,
	"./categories/headers/management": 84,
	"./categories/headers/management.jpg": 84,
	"./categories/headers/marketing": 85,
	"./categories/headers/marketing.jpg": 85,
	"./categories/headers/media": 86,
	"./categories/headers/media.jpg": 86,
	"./categories/headers/news": 87,
	"./categories/headers/news.jpg": 87,
	"./categories/headers/people": 88,
	"./categories/headers/people.jpg": 88,
	"./categories/headers/science": 89,
	"./categories/headers/science.jpg": 89,
	"./categories/headers/society-and-the-wider-world": 90,
	"./categories/headers/society-and-the-wider-world.jpg": 90,
	"./categories/headers/technology-and-innovation": 91,
	"./categories/headers/technology-and-innovation.jpg": 91,
	"./categories/headers/transport-and-travel": 92,
	"./categories/headers/transport-and-travel.jpg": 92,
	"./categories/headers/working-practices": 93,
	"./categories/headers/working-practices.jpg": 93,
	"./logo": 94,
	"./logo.png": 94,
	"./profile": 95,
	"./profile.png": 95
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 169;